export type { AccountData, AccountFn } from '@blockassetlabs/project';
